exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-link[data-v-17fb1c84] {\n  position: relative;\n}\n.video-link svg[data-v-17fb1c84] {\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  left: calc(50% - 7.5px);\n  top: calc(50% - 7.5px);\n  fill: white;\n}\n.fill-black svg[data-v-17fb1c84] {\n  fill: black;\n}", ""]);

// exports
